import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';

@Component({
	templateUrl: './404.component.html',
	styleUrls: ['./error.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class P404Component {
	public readonly homeRoute = AppRouteHelper.defaultRoute;
}
